<template>
  <div class="title">
    <div class="logo">OnceNature</div>
    <div class="info" v-if="ont !== true && true === false" v-on:click="toggleOn">
      <framer bordersize="small">
        info
      </framer>
    </div>
    <div class="info-menu" v-else>
      <!--<div class="close" v-on:click="toggleOn">&#10005;</div>-->
      <div v-html="texter.intro"></div>
            <div class="light-but" id="contribute">
              <framer bordersize="small" class="intro-buts">Contribute</framer>
              <div class="dropup">
                <framer bordersize="large">
                  Contribute<br>
                  <p v-html="texter.contribute"></p>
                  <!--<div>
                    <button @click="checkout">Checkout</button>
                  </div>-->
                </framer>
              </div>
            </div>
            <div class="light-but right-float" id="embed">
              <framer bordersize="small" class="intro-buts">Embed</framer>
              <div class="dropup">
                <framer bordersize="large">
                  Embed<br>
                  <p v-html="texter.embed"></p>
                </framer>
              </div>
            </div>
    </div>
  </div>
</template>

<script>
import Framer from '@/components/Framer'
export default {
  name: 'HeaderMenu',
  data () {
    return {
      msg: 'OnceNature',
      ont: false,
      texter: {
        intro: '',
        contribute: '',
        embed: '',
        donateAmount: 10
      }
    }
  },
  methods: {
    toggleOn () {
      this.ont = !this.ont
    },
    checkout () {
      /* this.$checkout.open({
        name: 'Once Nature',
        currency: 'USD',
        amount: this.donateAmount,
        token (token) {
          console.log(token)
        }
      }) */
      return false
    }
  },
  mounted () {
    this.texter = window.content()['texter']
  },
  components: { Framer }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  margin: 5px;
  margin-bottom: 10px;
}
.dropup {
  position: absolute;
  top: -60px; 
  left: -140px;
  width: 380px;
  height: auto;
  display: none;
  z-index: 999999999;
}
.intro-buts {
  padding: 10px;
}
.dropup p {
  text-align: left;
}
#contribute:hover .dropup, #contribute:focus .dropup {
  display: block;
}
#embed:hover .dropup, #embed:focus .dropup {
  display: block;
}
  .close {
    /*
    position: absolute;
    top: 0px;
    right: 0px;
    
    padding: 5px; */
    cursor: pointer;
    padding: 10px;
    padding-top: 4px;
  }
  .close:hover {
    opacity: 0.6;
  }
  .title {
    font-size: 5vh;
    margin-top: 2vh;
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    z-index: 99999;
  }
  .info-menu {
    position: relative;
    top: 10px;
    font-size: 18px;
    margin-top: 10px;
    width: 90%;
    max-width: 440px;
    margin: auto;
  }
  .info {
    margin-top: 10px;
    position: relative;
    display: inline-block;
    width: 100px;
    height: 60px;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderMenu.vue